export interface ICommunicationEntries {
    telephoneNumber: ITelephoneNumber[];
    email: IEmail[];
    other: IOther[];
}

export enum DispatchType {
    MOBILE_PRIVAT = 'TN1',
    TELEFON_PRIVAT = 'TP1',
    TELEFON_GESCHAEFT = 'TG2',
    MOBILE_GESCHAEFT = '1001',
    TELEFON_GESCHAEFT_ZENTRALE = 'TG1',
    TELEFON_FERIENWOHNUNG = '1002',
    E_MAIL_PRIVAT = 'EMP',
    E_MAIL_GESCHAEFT = 'EMG',
}

// order is significant
export const supportedPhoneDispatchTypes: DispatchType[] = [
    DispatchType.MOBILE_PRIVAT,
    DispatchType.TELEFON_PRIVAT,
    DispatchType.TELEFON_GESCHAEFT,
    DispatchType.MOBILE_GESCHAEFT,
    DispatchType.TELEFON_GESCHAEFT_ZENTRALE,
    DispatchType.TELEFON_FERIENWOHNUNG,
];

// order is significant
export const supportedEmailDispatchTypes: DispatchType[] = [DispatchType.E_MAIL_PRIVAT, DispatchType.E_MAIL_GESCHAEFT];

interface IContactType {
    communicationKey: number;
    dispatchType: DispatchType;
    relevantEntry?: boolean;
    comment?: string;
    marketing?: boolean;
    reachableFrom?: string; // e.g. 2020_06_12T06:31:31.109Z
    reachableUntil?: string; // e.g. 2020_06_12T06:31:31.109Z
}

export interface ITelephoneNumber extends IContactType {
    tel: string;
    masked?: boolean;
}

export interface IEmail extends IContactType {
    address: string;
}

export interface IOther extends IContactType {
    address: string;
    masked?: boolean;
}
